import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {updateDashboardOrderSetting} from "../../../../../api/main/DashboardApi";
import {DashboardSettingListElementType} from "../../detail/interface";


export const useUpdateDashboardOrderSetting = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: DashboardSettingListElementType[]) => updateDashboardOrderSetting(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "변경되었습니다.",
                    type: "alert",
                })
                
                qc.invalidateQueries({queryKey: ["readDashboardSetting"]})
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
